/**
 * @public
 */
export const DefaultHardBreakRenderer = (): string => '  \n'
